/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { ICategoryPageContentBlockData } from './category-page-content-block.data';
import { categoryNamePlacement, layoutOptionsImage, ICategoryPageContentBlockProps } from './category-page-content-block.props.autogenerated';

export interface ICategoryPageContentBlockViewProps extends ICategoryPageContentBlockProps<ICategoryPageContentBlockData> {
    categoryName: string;
    categoryInfo: string;
    categoryImageUrl: Msdyn365.IImageData;
    namePlacement: categoryNamePlacement;
    imageSizing: layoutOptionsImage;
    links: Msdyn365.ILinksData;
    headerCustomClass: string;
    imageCustomClass: string;
    descriptionCustomClass: string;
}

/**
 *
 * CategoryPageContentBlock component
 * @extends {React.PureComponent<ICategoryPageContentBlockProps<ICategoryPageContentBlockData>>}
 */
class CategoryPageContentBlock extends React.PureComponent<ICategoryPageContentBlockProps<ICategoryPageContentBlockData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const CategoryPageContentViewProps = {
        ...this.props,
        categoryName: config.categoryName,
        categoryInfo: config.categoryInfo,
        categoryImageUrl: config.categoryImage,
        namePlacement: config.categoryNamePlacement,
        imageSizing: config.layoutOptionsImage,
        links: config.links,
        headerCustomClass: config.headerCustomClass,
        imageCustomClass: config.imageCustomClass,
        descriptionCustomClass: config.descriptionCustomClass
        };
        return this.props.renderView(CategoryPageContentViewProps);
    }
}

export default CategoryPageContentBlock;
